module.exports = __webpack_public_path__ + "static/img/bg_callus.fb626e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/bg_callus.jpg
// module id = 0fFu
// module chunks = 1